// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './assets/style/default.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import navbar from "@/components/Navbar.vue"
import banner from "@/components/banner.vue"
Vue.component('navbar', navbar)
Vue.component('banner', banner)
Vue.config.productionTip = false
Vue.use(navbar)
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    $
})


// WEBPACK FOOTER //
// ./src/main.js